module.exports = {"title":"Sua VeloeTag ainda não chegou?","paragraph":"Seu pedido deve ser entregue em até 7 dias úteis depois da confirmação do pagamento. Se isso não acontecer, você pode pedir um novo para nós. O antigo será bloqueado e você só vai precisar escolher se quer receber no mesmo endereço ou em outro.","titleModal":"Problemas ao alterar seu endereço para novo envio!","shippingTitle":"FRETE","newAddressText":"Prefiro receber em outro endereço","cep":"CEP"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/FirstAccessIdentifierNotArrived/data.json
// module id = 1779
// module chunks = 0